// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"8393f76b","796":"c88fc170"}[chunkId] + ".chunk.js";
};